import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "from-to-currencies-inputs",
  components: {},
  props: {
    currency: {
      type: Object
    }
  },
  data() {
    return {
      searchFrom: "",
      searchTo: "",
      filteredCurrenciesList: [],
      showFromModal: false,
      showToModal: false
    };
  },
  computed: {
    ...mapGetters({
      getCurrencies: types.currencies.getters.GET_CURRENCIES
    }),
    computedFromCurrency: {
      get() {
        return this.currency.fromCurrency;
      },
      set(newValue) {
        this.$emit("onUpdate", {
          from_currency: newValue,
          to_currency: this.computedToCurrency
        });
      }
    },
    computedToCurrency: {
      get() {
        return this.currency.toCurrency;
      },
      set(newValue) {
        this.$emit("onUpdate", {
          from_currency: this.computedFromCurrency,
          to_currency: newValue
        });
      }
    },
    currenciesList() {
      return [...this.getCurrencies];
    },
    filterFromCurrency() {
      if (this.currenciesList) {
        return this.currenciesList.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(
                this.searchFrom.toLowerCase().replace(/[^\p{L}]/gu, "")
              ) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(
                this.searchFrom.toLowerCase().replace(/[^\p{L}]/gu, "")
              ) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.searchFrom.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    },
    filterToCurrency() {
      if (this.filteredCurrenciesList) {
        return this.filteredCurrenciesList.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(
                this.searchTo.toLowerCase().replace(/[^\p{L}]/gu, "")
              ) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(
                this.searchTo.toLowerCase().replace(/[^\p{L}]/gu, "")
              ) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.searchTo.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    }
  },
  mounted() {},
  methods: {
    clickOnModalFromCurrency(value) {
      this.filterCurrenciesList(value.iso);
      this.searchFrom = "";
      this.showFromModal = false;
      this.computedFromCurrency = value.iso;
    },
    clickOnModalToCurrency(value) {
      this.searchTo = "";
      this.showToModal = false;
      this.computedToCurrency = value.iso;
    },
    changeCurrencyInput({ target: { value } }) {
      this.$emit("input", value);
    },
    closeFromModal() {
      this.$refs.searchModal.scrollTop = 0;
      this.showFromModal = false;
      this.searchFrom = "";
    },
    closeToModal() {
      this.$refs.searchModal.scrollTop = 0;
      this.showToModal = false;
      this.searchTo = "";
    },
    onFocusInput() {
      this.$emit("onFocus", true);
    },
    onBlurInput() {
      this.$emit("onBlur", false);
    },
    filterCurrenciesList(iso) {
      this.filteredCurrenciesList = [];
      this.currenciesList.forEach(elem => {
        if (elem.iso !== iso) {
          this.filteredCurrenciesList.push(elem);
        }
      });
    }
  }
};
